var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarD = function SvgDefaultAvatarD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9 55.3c8.9 0 15.8-6.4 15.8-15.6 0-8.4-6.3-14.6-15.8-14.6-2.3 0-4.7.2-6.5.2h-2.6c-2.9 0-4.8.3-4.8 1.5 0 .9 1 1.2 3.1 1.3.5.2.6 2.1.6 4.5v15.2c0 2.2-.1 4.3-.6 4.5-2.2.1-3.1.4-3.1 1.4 0 1.2 2 1.5 4.9 1.5h2.4c1.7-.1 4.4.1 6.6.1zm-5.1-7.5V32.7c0-2.3 0-4.1.5-4.4 1.1-.3 2.6-.3 3.9-.3 7.3 0 11 5.5 11 12.5 0 5.8-2.9 12.1-10.5 12.1-1.7 0-3.2-.1-4.4-.4-.5-.4-.5-2.4-.5-4.4z"
  })));
};
export default SvgDefaultAvatarD;